import React, { Component, Fragment } from 'react'


export default class Form extends Component {

    state = {
        details: {...this.props.details},
        id: this.props.details.key,
        information: {...this.props.information},
    }

    handleChangeTimeTable = (e, key) => {
        const value = e.target.value.replace(/[^h0-9_-]/, '')
        const dataPeriod = e.target.dataset.period
        const dataDay = e.target.dataset.day
        const doctor = this.state.details
        doctor.timetable[dataDay].opening_hours[dataPeriod] = value
        this.props.handleAdminChange(key, doctor)
    }

    handleChangeText = (e, key) => {
        const value = e.target.value.replace(/[^A-zÀ-ÿ0-9_ :,]+/, '')
        const name = e.target.name
        const doctor = this.state.details
        doctor[name] = value
        this.props.handleAdminChange(key, doctor)
    }

    handleCheck = (e, key) => {
        const name = e.target.name
        let isCheck = e.target.checked
        if(isCheck){
            const doctor = this.state.details
            doctor[name] = true
            this.props.handleAdminChange(key, doctor)
        }else{
            const doctor = this.state.details
            doctor[name] = false
            this.props.handleAdminChange(key, doctor) 
        }
    }

    handleLink = (e, key) => {
        const value = e.target.value
        const name = e.target.name
        const doctor = this.state.details
        doctor[name] = value
        this.props.handleAdminChange(key, doctor)
    }

    handleInformationText = (e, key) => {
        const value = e.target.value.replace(/[^A-zÀ-ÿ0-9_ :(),]+/, '')
        const information = this.state.information
        information[key] = value
        this.props.handleInformationChange(information)
    }

    requireImage = (image) => {
        try{
            return require(`../img/${image}`)
        }catch(err){

        }
    }


    render() {
        const key = this.state.id
        const marginTop = { marginTop: '1.5rem' }
        
        return (
            <div className='card'>
                <div className='doctor'>
                    <h1>{this.state.details.name}</h1>
                </div>
                <div className="form__group">
                    <label>Phone / Téléphone</label>
                    <input onChange={(e) => this.handleChangeText(e, key)}
                        value={this.state.details.phone} 
                        name='phone'/>
                </div>
                
                <div className="form__group">
                    <label>Activity / Activité <img src={this.requireImage('uk_flag.jpg')} /></label>
                    <input onChange={(e) => this.handleChangeText(e, key)}
                        value={this.state.details.activityEnglish} 
                        name='activityEnglish'/>
                </div>

                <div className="form__group">
                    <label>Activity / Activité <img src={this.requireImage('france_flag.jpg')} /></label>
                    <input onChange={(e) => this.handleChangeText(e, key)}
                        value={this.state.details.activityFrench} 
                        name='activityFrench'/>
                </div>

                <div className="form__group form__one_line">
                    <label>Only on appointment / Seulement sur rendez-vous</label>   
                    {this.state.details.rdv === true ? 
                        <input type='checkbox'
                        onChange={(e) => this.handleCheck(e, key)}
                        checked={true}
                        value={this.state.details.rdv} 
                        name='rdv'
                        className='form__checkbox'/>
                            :
                        <input type='checkbox'
                        onChange={(e) => this.handleCheck(e, key)}
                        checked={false}
                        value={this.state.details.rdv} 
                        name='rdv'
                        className='form__checkbox'/>
                       
                    }
                </div>

                <div className="form__group">
                    <label>Spoken languages / Langues parlées <img src={this.requireImage('uk_flag.jpg')} /></label>
                    <input onChange={(e) => this.handleChangeText(e, key)}
                        value={this.state.details.languagesEnglish} 
                        name='languagesEnglish'/>
                </div>

                <div className="form__group">
                    <label>Spoken languages / Langues parlées <img src={this.requireImage('france_flag.jpg')} /></label>
                    <input onChange={(e) => this.handleChangeText(e, key)}
                        value={this.state.details.languagesFrench} 
                        name='languagesFrench'/>
                </div>


                    {!this.state.details.doctenaDisplay ?
                        <Fragment>
                        <div className="form__group">
                            <label>Link to online appointment / Lien vers rdv en ligne</label>

                            <div className="form__one_line">

                                <input type='checkbox'
                                       onChange={(e) => this.handleCheck(e, key)}
                                       checked={false}
                                       value={this.state.details.doctenaDisplay}
                                       name='doctenaDisplay'
                                       className='form__checkbox form__info--checkbox'/>
                                <span className="form__info">If this box is unchecked, the reservation button does not appear / <br /> Si cette case est décochée, le bouton de réservation n'apparaît pas</span>

                            </div>
                        </div>
                        <div className="form__group">
                            <label>Information about making an appointment / Informations concernant la prise de rdv <img src={this.requireImage('uk_flag.jpg')} /></label>
                            <input onChange={(e) => this.handleLink(e, key)}
                                   placeholder="ex : Appointments from April 2023"
                                   value={this.state.details.doctenaMessageEn}
                                   name='doctenaMessageEn'/>
                        </div>
                            <div className="form__group">
                                <label>Information about making an appointment / Informations concernant la prise de rdv <img src={this.requireImage('france_flag.jpg')} /></label>
                                <input onChange={(e) => this.handleLink(e, key)}
                                       placeholder="ex : RDV à partir d'avril 2023"
                                       value={this.state.details.doctenaMessageFr}
                                       name='doctenaMessageFr'/>
                            </div>
                        </Fragment>


                    :
                        <div className="form__group">
                            <label>Link to online appointment / Lien vers rdv en ligne</label>
                            <div className="form__one_line">
                                 <input type='checkbox'
                                onChange={(e) => this.handleCheck(e, key)}
                                checked={true}
                                value={this.state.details.doctenaDisplay}
                                name='doctenaDisplay'
                                className='form__checkbox'/>
                                <input onChange={(e) => this.handleLink(e, key)}
                                placeholder='ex: https://website.lu/your-name/'
                                value={this.state.details.doctenaLink}
                                name='doctenaLink'/>
                            </div>
                        </div>
                        
                    }
                
                <table>
                    <thead>
                    <tr>
                        <th></th>
                        <th>Morning / Matin</th>
                        <th>Afternoon / Après-midi</th>
                    </tr>
                    </thead>
                    <tbody> 
                        <tr>
                            <th>Monday <br /> Lundi</th>
                            <td>
                                <input onChange={(e) => this.handleChangeTimeTable(e, key)}
                                data-day='0'
                                data-period='0'
                                value={this.state.details.timetable[0].opening_hours[0]} />
                            </td>
                            <td>
                                <input onChange={(e) => this.handleChangeTimeTable(e, key)}
                                data-day='0'
                                data-period='1'
                                value={this.state.details.timetable[0].opening_hours[1]} />
                            </td>
                        </tr>
                        <tr>
                            <th>Tuesday  <br /> Mardi</th>
                            <td>
                                <input onChange={(e) => this.handleChangeTimeTable(e, key)}
                                data-day='1'
                                data-period='0'
                                value={this.state.details.timetable[1].opening_hours[0]} />
                            </td>
                            <td>
                                <input onChange={(e) => this.handleChangeTimeTable(e, key)}
                                data-day='1'
                                data-period='1'
                                value={this.state.details.timetable[1].opening_hours[1]} />
                            </td>
                        </tr>
                        <tr>
                            <th>Wednesday  <br /> Mercredi</th>
                            <td>
                                <input onChange={(e) => this.handleChangeTimeTable(e, key)}
                                data-day='2'
                                data-period='0'
                                value={this.state.details.timetable[2].opening_hours[0]} />
                            </td>
                            <td>
                                <input onChange={(e) => this.handleChangeTimeTable(e, key)}
                                data-day='2'
                                data-period='1'
                                value={this.state.details.timetable[2].opening_hours[1]} />
                            </td>
                        </tr>
                        <tr>
                            <th>Thursday  <br /> Jeudi</th>
                            <td>
                                <input onChange={(e) => this.handleChangeTimeTable(e, key)}
                                data-day='3'
                                data-period='0'
                                value={this.state.details.timetable[3].opening_hours[0]} />
                            </td>
                            <td>
                                <input onChange={(e) => this.handleChangeTimeTable(e, key)}
                                data-day='3'
                                data-period='1'
                                value={this.state.details.timetable[3].opening_hours[1]} />
                            </td>
                            </tr>
                        <tr>
                            <th>Friday  <br /> Vendredi</th>
                            <td>
                                <input onChange={(e) => this.handleChangeTimeTable(e, key)}
                                data-day='4'
                                data-period='0'
                                value={this.state.details.timetable[4].opening_hours[0]} />
                            </td>
                            <td>
                                <input onChange={(e) => this.handleChangeTimeTable(e, key)}
                                data-day='4'
                                data-period='1'
                                value={this.state.details.timetable[4].opening_hours[1]} />
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div className="form__group">
                    <label>Appear on the Bonnevoie Medical Centre Annex page / Apparaitre sur la page Centre médical Bonnevoie Annexe</label>

                    {this.state.details.isInAnnexe === true ?
                        <input type='checkbox'
                               onChange={(e) => this.handleCheck(e, key)}
                               checked={true}
                               value={this.state.details.isInAnnexe}
                               name='isInAnnexe'
                               className='form__checkbox'/>
                        :
                        <input type='checkbox'
                               onChange={(e) => this.handleCheck(e, key)}
                               checked={false}
                               value={this.state.details.isInAnnexe}
                               name='isInAnnexe'
                               className='form__checkbox'/>
                    }
                    <span className="form__info">If this box is checked, your information sheet will appear on the Bonnevoie Medical Centre Annex page / <br /> Si cette case est cochée, votre fiche de renseignements apparaîtra sur la page Centre Médical Bonnevoie Annexe</span>
                </div>
            
                {this.state.details.permissionInformation &&
                <Fragment>
                    <div className='doctor' style={marginTop}>
                        <h1>Information</h1>
                    </div>

                    <div className="form__group">
                        <label>First row / Première ligne <img src={this.requireImage('uk_flag.jpg')} /></label>
                        <textarea value={this.state.information.information1En} onChange={(e) => this.handleInformationText(e, 'information1En')} />
                    </div>

                    <div className="form__group">
                        <label>First row / Première ligne <img src={this.requireImage('france_flag.jpg')} /></label>
                        <textarea value={this.state.information.information1Fr} onChange={(e) => this.handleInformationText(e, 'information1Fr')} />
                    </div>

                    <div className="form__group">
                        <label>Second row / Deuxième ligne <img src={this.requireImage('uk_flag.jpg')} /></label>
                        <textarea value={this.state.information.information2En} onChange={(e) => this.handleInformationText(e, 'information2En')} />
                    </div>

                    <div className="form__group">
                        <label>Second row / Deuxième ligne <img src={this.requireImage('france_flag.jpg')} /></label>
                        <textarea value={this.state.information.information2Fr} onChange={(e) => this.handleInformationText(e, 'information2Fr')} />
                    </div>

                    <div className="form__group">
                        <label>Third row / Troisième ligne <img src={this.requireImage('uk_flag.jpg')} /></label>
                        <textarea value={this.state.information.information3En} onChange={(e) => this.handleInformationText(e, 'information3En')} />
                    </div>

                    <div className="form__group">
                        <label>Third row / Troisième ligne <img src={this.requireImage('france_flag.jpg')} /></label>
                        <textarea value={this.state.information.information3Fr} onChange={(e) => this.handleInformationText(e, 'information3Fr')} />
                    </div>

                    <div className="form__group">
                        <label>Fourth row / Quatrième ligne <img src={this.requireImage('uk_flag.jpg')} /></label>
                        <textarea value={this.state.information.information4En} onChange={(e) => this.handleInformationText(e, 'information4En')} />
                    </div>

                    <div className="form__group">
                        <label>Fourth row / Quatrième ligne <img src={this.requireImage('france_flag.jpg')} /></label>
                        <textarea value={this.state.information.information4Fr} onChange={(e) => this.handleInformationText(e, 'information4Fr')} />
                    </div>
                
                </Fragment>
                
                
                }
                </div>
              )
        
    }
}

